import React, { useState, useEffect } from 'react';
import { supabase } from '@/lib/supabase';

function toDatetimeLocal(value?: string | null) {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
  return localDate.toISOString().slice(0, 16);
}

function fromDatetimeLocal(value: string) {
  return value ? new Date(value).toISOString() : null;
}

export default function GerenciarLive() {
  const [form, setForm] = useState({
    url: '',
    ativo: true,
    titulo: '',
    descricao: '',
    scheduled_start_at: '',
    scheduled_end_at: '',
    seo_title: '',
    seo_description: '',
    seo_keywords: '',
  });

  const [carregando, setCarregando] = useState(false);

  useEffect(() => {
    async function carregarDados() {
      const { data } = await supabase
        .from('transmissoes')
        .select('*')
        .eq('id', 1)
        .single();

      if (data) {
        setForm({
          url: data.url || '',
          ativo: data.ativo ?? true,
          titulo: data.titulo || '',
          descricao: data.descricao || '',
          scheduled_start_at: toDatetimeLocal(data.scheduled_start_at),
          scheduled_end_at: toDatetimeLocal(data.scheduled_end_at),
          seo_title: data.seo_title || '',
          seo_description: data.seo_description || '',
          seo_keywords: data.seo_keywords || '',
        });
      }
    }

    carregarDados();
  }, []);

  const atualizarCampo = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  const atualizarAtivo = (e: React.ChangeEvent<HTMLInputElement>) => {
    setForm({
      ...form,
      ativo: e.target.checked,
    });
  };

  const salvar = async (e: React.FormEvent) => {
    e.preventDefault();

    setCarregando(true);

    const { error } = await supabase
      .from('transmissoes')
      .update({
        url: form.url,
        ativo: form.ativo,
        titulo: form.titulo,
        descricao: form.descricao,
        scheduled_start_at: fromDatetimeLocal(form.scheduled_start_at),
        scheduled_end_at: fromDatetimeLocal(form.scheduled_end_at),
        seo_title: form.seo_title,
        seo_description: form.seo_description,
        seo_keywords: form.seo_keywords,
        updated_at: new Date().toISOString(),
      })
      .eq('id', 1);

    setCarregando(false);

    if (error) {
      alert('Erro ao salvar: ' + error.message);
    } else {
      alert('Configuracoes atualizadas com sucesso!');
    }
  };

  return (
    <div className="bg-white rounded-xl border border-alvinegro-border p-6">
      <h2 className="font-serif font-bold text-xl text-alvinegro-black mb-6">
        Gerenciar Transmissao Ao Vivo
      </h2>

      <form onSubmit={salvar} className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-alvinegro-dark mb-1">
            URL da Transmissao
          </label>

          <input
            type="text"
            name="url"
            value={form.url}
            onChange={atualizarCampo}
            className="w-full px-4 py-2.5 rounded-lg border border-alvinegro-border"
          />
        </div>

        <label className="flex items-center justify-between gap-4 rounded-xl border border-alvinegro-border bg-alvinegro-light/40 p-4 cursor-pointer">
          <span>
            <span className="block text-sm font-semibold text-alvinegro-black">
              Transmissao ativa
            </span>
            <span className="block text-xs text-alvinegro-muted mt-1">
              Desligue para ocultar o player sem apagar a URL cadastrada.
            </span>
          </span>

          <input
            type="checkbox"
            checked={form.ativo}
            onChange={atualizarAtivo}
            className="h-5 w-5 accent-alvinegro-black"
          />
        </label>

        <div>
          <label className="block text-sm font-medium text-alvinegro-dark mb-1">
            Titulo
          </label>

          <input
            type="text"
            name="titulo"
            value={form.titulo}
            onChange={atualizarCampo}
            className="w-full px-4 py-2.5 rounded-lg border border-alvinegro-border"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-alvinegro-dark mb-1">
            Descricao
          </label>

          <textarea
            name="descricao"
            rows={6}
            value={form.descricao}
            onChange={atualizarCampo}
            className="w-full px-4 py-2.5 rounded-lg border border-alvinegro-border"
          />
        </div>

        <div className="rounded-xl border border-alvinegro-border bg-alvinegro-light/40 p-4">
          <h3 className="font-semibold text-base text-alvinegro-black mb-3">
            Agendamento do Ao Vivo
          </h3>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-alvinegro-dark mb-1">
                Iniciar em
              </label>

              <input
                type="datetime-local"
                name="scheduled_start_at"
                value={form.scheduled_start_at}
                onChange={atualizarCampo}
                className="w-full px-4 py-2.5 rounded-lg border border-alvinegro-border bg-white"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-alvinegro-dark mb-1">
                Encerrar em
              </label>

              <input
                type="datetime-local"
                name="scheduled_end_at"
                value={form.scheduled_end_at}
                onChange={atualizarCampo}
                className="w-full px-4 py-2.5 rounded-lg border border-alvinegro-border bg-white"
              />
            </div>
          </div>

          <p className="mt-3 text-xs text-alvinegro-muted">
            Deixe os dois campos em branco para exibir a transmissao sempre que houver URL cadastrada.
          </p>
        </div>

        <hr />

        <h3 className="font-semibold text-lg">
          Configuracoes SEO
        </h3>

        <div>
          <label className="block text-sm font-medium text-alvinegro-dark mb-1">
            SEO Title
          </label>

          <input
            type="text"
            name="seo_title"
            value={form.seo_title}
            onChange={atualizarCampo}
            className="w-full px-4 py-2.5 rounded-lg border border-alvinegro-border"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-alvinegro-dark mb-1">
            SEO Description
          </label>

          <textarea
            name="seo_description"
            rows={4}
            value={form.seo_description}
            onChange={atualizarCampo}
            className="w-full px-4 py-2.5 rounded-lg border border-alvinegro-border"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-alvinegro-dark mb-1">
            SEO Keywords
          </label>

          <textarea
            name="seo_keywords"
            rows={3}
            value={form.seo_keywords}
            onChange={atualizarCampo}
            className="w-full px-4 py-2.5 rounded-lg border border-alvinegro-border"
          />
        </div>

        <button
          type="submit"
          disabled={carregando}
          className="w-full bg-alvinegro-black text-white py-2.5 rounded-full text-sm font-medium hover:bg-alvinegro-dark transition-colors disabled:opacity-50"
        >
          {carregando ? 'Salvando...' : 'Salvar Configuracoes'}
        </button>
      </form>
    </div>
  );
}
